import React from "react";
import styled from "styled-components";
import { ProductConsumer } from "../../context";

export default function ProductFilter() {
	return (
		<ProductConsumer>
			{(value) => {
				const { search, category, handleChange, menu } = value;

				let companies = new Set();
				companies.add("Alle");
				for (let product in menu) {
					companies.add(menu[product]["category"]);
				}
				companies = [ ...companies ];


				return (
					<div className="row my-5">
						<div className="col-10 mx-auto">
							<FilterWrapper>
								<div>
									<label htmlFor="search">søg</label>
									<input
										type="text"
										name="search"
										id="search"
										onChange={handleChange}
										value={search}
										className="filter-item"
									/>
								</div>
								<div>
									<label htmlFor="kategorie">Kategori</label>
									<select
										name="category"
										id="category"
										className="filter-item"
										onChange={handleChange}
										value={category}
									>
										{companies.map((category, index) => {
											return (
												<option key={index} value={category}>
													{category}
												</option>
											);
										})}
									</select>
								</div>
								{/* <div>
									<label htmlFor="price">
										<p className="mb-2">
											product price :<span>$ {price}</span>{" "}
										</p>
									</label>
									<input
										type="range"
										name="price"
										id="price"
										min={min}
										max={max}
										className="filter-price"
										value={price}
										onChange={handleChange}
									/>
								</div>
								<div>
									<label htmlFor="shipping" className="mx-2">
										free shipping
									</label>
									<input
										name="shipping"
										id="shipping"
										type="checkbox"
										onChange={handleChange}
										checked={shipping && true}
									/>
								</div> */}
							</FilterWrapper>
						</div>
					</div>
				);
			}}
		</ProductConsumer>
	);
}
const FilterWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	grid-column-gap: 2rem;
	grid-row-gap: 1rem;
	label {
		font-weight: bold;
		text-transform: capitalize;
	}
	.filter-item,
	.filter-price {
		display: block;
		width: 100%;
		background: transparent;
		border-radius: 0.5rem;
		border: 2px solid var(--darkGrey);
	}
`;